import { useNavigate } from "react-router-dom";

const EmptyParticipantShop = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    // Navigate to the page where the user can enter the participant ID.
    navigate("/register-or-shop"); // Replace with your actual route for entering participant ID
  };

  return (
    <div>
      <p>
        No participant found. If you have a participant ID, please enter it
        here:
      </p>
      <button onClick={handleNavigate}>Enter Participant ID</button>
    </div>
  );
};

export default EmptyParticipantShop;
